export function getPaymentStatusLabel(paymentStatus: string) {
    if (paymentStatus === 'BLOCKED') {
        return '❌';
    } else if (paymentStatus === 'WARNING') {
        return '⚠️';
    }
}
